import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { API_LOGIN_REFRESH, API_LOGIN_UNIVERSAL } from 'constants/api';
import {
  logout,
  profileInit,
  ProfileRefreshTokensResponse,
  profileSet,
} from 'store/profile';
import api from './index';
import store from '../store';

function addUnauthorizedInterceptor(
  axiosInstance: AxiosInstance,
  setProfile: (profile: ProfileRefreshTokensResponse) => void,
  logoutFn: () => void,
) {
  axiosInstance.interceptors.response.use(
    (res: AxiosResponse) => res,
    async (err: AxiosError) => {
      const originalConfig = err.config as AxiosRequestConfig & {
        retry: boolean;
      };

      if (err.response) {
        if (
          err.response.status === 401 &&
          !originalConfig.retry &&
          [API_LOGIN_REFRESH, API_LOGIN_UNIVERSAL].every(
            (url) => !originalConfig.url?.startsWith(url),
          )
        ) {
          originalConfig.retry = true;

          try {
            const { data } = await axiosInstance.post(API_LOGIN_REFRESH);
            setProfile(data);
            return await axiosInstance(originalConfig);
          } catch (error) {
            return Promise.reject(error);
          }
        }

        if (
          err.response.status === 401 &&
          originalConfig.url?.startsWith(API_LOGIN_REFRESH)
        ) {
          logoutFn();
        }
      }

      return Promise.reject(err);
    },
  );
}

export default function initApi() {
  addUnauthorizedInterceptor(
    api.axios,
    (profile: ProfileRefreshTokensResponse) =>
      store.dispatch(profileSet(profile)),
    () => store.dispatch(logout()),
  );

  store.dispatch(profileInit());
}
